'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.sortBy.implement(Array, function (getSortValue, arr) {
  return (0, _immutable.Seq)(arr).sortBy(getSortValue).toArray();
});

_TransmuteCollection.sortBy.implementInherited(_immutable.Iterable, function (getSortValue, subject) {
  return subject.sortBy(getSortValue);
});

_TransmuteCollection.sortBy.implement(Object, function (getSortValue, obj) {
  return (0, _immutable.Seq)(obj).sortBy(getSortValue).toObject();
});

exports.default = _TransmuteCollection.sortBy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/internal/_sortBy.js
// module id = 888
// module chunks = 2 3